module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0122.jpg?v=b7305e06";